import { render, staticRenderFns } from "./CartProductsTable.vue?vue&type=template&id=19667a64&scoped=true&"
import script from "./CartProductsTable.vue?vue&type=script&lang=js&"
export * from "./CartProductsTable.vue?vue&type=script&lang=js&"
import style0 from "./CartProductsTable.vue?vue&type=style&index=0&id=19667a64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19667a64",
  null
  
)

export default component.exports